<template>
  <div style=" line-height: 20px; overflow: auto;height: inherit;">
    <div v-for="(item, index) in purchaseDetail" :key="index">
      {{ item.productName + " " + item.amount + " " + item.amountTypeName + " ( Alınan & İşlenen : " + item.amount + " - " + item.arrivedAmount + " ) " }}
    </div>
  </div>
</template>

<script>
export default {
  name: "CellRendererPurchaseDetailListToString",
  data() {
    return {
      purchaseDetail: "",
      span: "",
    };
  },
  computed: {
    url() {
      return "//" + this.params.data.purchaseId;
    },
  },
  beforeMount() {
    this.purchaseDetail = this.params.value;
  },
};
</script>
